module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "is-link",
    attrs: {
      "href": _vm.queryString,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.showTitle) ? _c('span', {
    staticClass: "no-highlight"
  }, [_vm._v(_vm._s(_vm.query))]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d2d3a4f6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2d3a4f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VLink.vue
// module id = 157
// module chunks = 1